import './input.scss';

import React from 'react';
import DropdownDate from 'react-dropdown-date';

const DateInput = ({ input, width, type, name, placeholder, meta: { touched, error } }) => {
	const currentYear = new Date().getFullYear();
	const forDOB = new Date(currentYear - 100, 0);
	const forOthers = new Date(currentYear - 12, 0);
	let today = new Date();

	return (
		<div className="date-picker">
			<DropdownDate
				className="form-control"
				type={type}
				startDate={input.name === 'userDOB' ? forDOB.toDateString() : forOthers.toDateString()}
				endDate={today.toDateString()}
				onBlur={input.onBlur}
				selectedDate={null}
				order={[ 'month', 'day', 'year' ]}
				options={{
					yearReverse: true
				}}
				ids={// optional
				{
					year: `${input.name}-year`,
					month: `${input.name}-month`,
					day: `${input.name}-day`
				}}
				defaultValues={// optional
				{
					year: 'Select year',
					month: 'Select month',
					day: 'Select day'
				}}
				onDateChange={(e) => input.onChange(e)}
			/>
			{touched && error && <label className="error-label">{error}</label>}
		</div>
	);
};

export default DateInput;
